import React, { FunctionComponent, useState } from 'react';
import { Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import SpecificationsAccordionContent from '../specificationsAccordionContent/SpecificationsAccordionContent';
import specificationsDetailItemStyles from './specificationsDetailItemStyles';
import GenericAccordion from '../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import { IFeatureItem } from '../../../../../../gqlCommon/model/IVariants';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface ISpecificationsDetailItemProps {
  category?: string;
  specifications: IFeatureItem[];
  hasTranslation?: boolean;
}

const SpecificationsDetailItem: FunctionComponent<ISpecificationsDetailItemProps> = ({
  category,
  specifications,
  hasTranslation,
}) => {
  const styles = specificationsDetailItemStyles();
  const [expanded, setExpanded] = useState(false);
  const dataTest = category?.replace(/ /g, '_');

  return (
    <GenericAccordion
      dataTest={`customise:specifications:${dataTest}`}
      summary={
        <Typography
          color="textSecondary"
          variant="subtitle1"
          className={styles.title}
          data-test="customise:specifications_category_title"
        >
          {hasTranslation ? (
            <Translation id={`trans__configurator__customise_page_full_specs_modal__${category}_label`} />
          ) : (
            category
          )}
        </Typography>
      }
      details={
        <Table>
          <TableBody>
            {specifications?.map((specification, index) => {
              if (specification.value === '') {
                return null;
              }

              return (
                <SpecificationsAccordionContent
                  key={index}
                  specification={specification}
                  hasTranslation={hasTranslation && !!specification.value}
                />
              );
            })}
          </TableBody>
        </Table>
      }
      expanded={expanded}
      defaultExpanded={false}
      setExpanded={setExpanded}
      classes={{
        accordionSummary: styles.accordionSummary,
      }}
    />
  );
};

export default SpecificationsDetailItem;
